import firebase from 'firebase/app';
import 'firebase/auth';
import React, { useCallback } from 'react';
import { memoNamed } from '../utils/react/memo-named';
import { Page } from './App';
import MediaQuery from 'react-responsive';
import MenuIcon from '@material-ui/icons/Menu';
import DvrIcon from '@material-ui/icons/Dvr';
import ChatIcon from '@material-ui/icons/Chat';
import {
  AppBar,
  Button,
  Drawer,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  Toolbar,
  Typography,
} from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
// import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import PersonIcon from '@material-ui/icons/Person';
import { useBooleanState } from '../utils/react/use_boolean_state';

interface Props {
  isAdmin: boolean;
  logout: () => void;
  page: string;
  goToPage: (page: Page) => void;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
    },
    menuButton: {
      marginRight: theme.spacing(2),
    },
    title: {
      flexGrow: 1,
    },
    button: {
      marginRight: theme.spacing(2),
    },
    list: {
      width: 250,
    },
  })
);

export const Header = memoNamed<Props>('Header', (props) => {
  const classes = useStyles();
  const [drawerIsOpen, setDrawerIsOpen, setDrawerIsClosed] = useBooleanState(
    false
  );
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (): void => {
    setAnchorEl(null);
  };
  const logout = useCallback(() => {
    props.logout();
    firebase
      .auth()
      .signOut()
      .then(() => {
        props.goToPage('LoginPage');
      })
      .catch((err) => {
        console.error(err);
        props.goToPage('LoginPage');
      });
  }, [props]);

  const goToMyPage = useCallback(() => {
    props.goToPage('MyPage');
  }, [props]);
  const goToNames = useCallback(() => {
    props.goToPage('Names');
  }, [props]);
  const goToBoard = useCallback(() => {
    props.goToPage('Board');
  }, [props]);
  const goToAdminAddMember = useCallback(() => {
    handleClose();
    props.goToPage('AdminAddMember');
  }, [props]);
  const goToAdminMail = useCallback(() => {
    handleClose();
    props.goToPage('AdminMail');
  }, [props]);
  const goToAdminCSV = useCallback(() => {
    handleClose();
    props.goToPage('AdminCSV');
  }, [props]);
  return (
    <div className={classes.root}>
      <AppBar position='fixed' color='inherit'>
        <Toolbar>
          <MediaQuery query='(max-width: 768px)'>
            <IconButton
              edge='start'
              className={classes.menuButton}
              color='primary'
              onClick={setDrawerIsOpen}
            >
              <MenuIcon />
              Menu
            </IconButton>
          </MediaQuery>
          <Typography variant='h6' className={classes.title}>
            Togen-Meibo
          </Typography>
          <MediaQuery query='(min-width: 768px)'>
            <Button
              color='inherit'
              onClick={goToMyPage}
              className={classes.button}
            >
              <PersonIcon color='inherit' />
              マイページ
            </Button>
            <Button
              color='inherit'
              onClick={goToNames}
              className={classes.button}
            >
              <DvrIcon />
              名簿
            </Button>
            <Button
              color='inherit'
              onClick={goToBoard}
              className={classes.button}
            >
              <ChatIcon />
              掲示板
            </Button>
            {props.isAdmin ? (
              <div>
                <Button
                  variant='contained'
                  color='primary'
                  onClick={handleClick}
                  className={classes.button}
                >
                  管理
                </Button>
                <Menu
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                >
                  <MenuItem onClick={goToAdminAddMember}>会員登録</MenuItem>
                  <MenuItem onClick={goToAdminCSV}>
                    CSVインポート/エクスポート
                  </MenuItem>
                  <MenuItem onClick={goToAdminMail}>メールリスト取得</MenuItem>
                </Menu>
              </div>
            ) : undefined}
            <Button variant='contained' onClick={logout}>
              ログアウト
            </Button>
          </MediaQuery>
        </Toolbar>
      </AppBar>
      <div onClick={setDrawerIsClosed} onKeyDown={setDrawerIsClosed}>
        <Drawer anchor='left' open={drawerIsOpen} onClose={setDrawerIsClosed}>
          <div role='presentation' className={classes.list}>
            <List>
              <ListItem button onClick={goToMyPage}>
                <ListItemIcon>
                  <PersonIcon />
                </ListItemIcon>
                <ListItemText primary='マイページ' />
              </ListItem>
              <ListItem button onClick={goToNames}>
                <ListItemIcon>
                  <DvrIcon />
                </ListItemIcon>
                <ListItemText primary='名簿' />
              </ListItem>
              <ListItem button onClick={goToBoard}>
                <ListItemIcon>
                  <ChatIcon />
                </ListItemIcon>
                <ListItemText primary='掲示板' />
              </ListItem>
            </List>
            {props.isAdmin ? (
              <div>
                <Divider />
                <List>
                  <ListItem button onClick={goToAdminAddMember}>
                    <ListItemText primary='会員登録' />
                  </ListItem>
                  <ListItem button onClick={goToAdminCSV}>
                    <ListItemText primary='CSVインポート/エクスポート' />
                  </ListItem>
                  <ListItem button onClick={goToAdminMail}>
                    <ListItemText primary='メールリスト出力' />
                  </ListItem>
                </List>
              </div>
            ) : undefined}
            <Divider />
            <List>
              <ListItem button onClick={logout}>
                <ListItemText primary='ログアウト' />
              </ListItem>
            </List>
          </div>
        </Drawer>
      </div>
    </div>
  );
});

Header.displayName = 'Header';
